<div id="deliveries_content">
  <div class="table-box">
    <div class="table-border scrollable-container">
      <table class="div-style-table">
        <thead>
          <tr class="table-header">
            <th (click)="sortByDate()">{{'DELIVERIES.DATE' | translate }} <i class="fas"
            [class.fa-sort-down]="arrowSortDate" [class.fa-sort-up]="!arrowSortDate"></i></th>
            <th>{{'DELIVERIES.TIMES' | translate }}</th>
            <th>{{'DELIVERIES.USERS' | translate }}</th>
            <th>{{'DELIVERIES.HOLE_COUNT' | translate }}</th>
            <th>{{'DELIVERIES.KGSEND' | translate }}</th>
            <th>{{'DELIVERIES.DETONATORS' | translate }}</th>
            <th>{{'DELIVERIES.CARTRIDGES' | translate }}</th>
            <th>Boosters</th>
            <th *showIfHasRole="'edit_delivery'"></th>
          </tr>
        </thead>
        <tbody>
          @for (delivery of deliveries(); track delivery) {
            <tr class="table-row">
              <td>{{delivery ? (delivery.startTime | date:'dd/MM/yyy') : 'not set'}}</td>
              <td>
                <div class="d-flex flex-column justify-content-center">
                  <div class="name">Start: {{delivery ? (delivery.startTime | date:'HH:mm') : 'not set'}}
                  </div>
                  <div class="descripition"> End:
                    {{delivery ? (delivery.endTime | date:'HH:mm') : 'not set'}}
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex flex-column justify-content-center">
                  <div class="name">Blaster: {{delivery?.blaster || 'not set'}}</div>
                </div>
                <div class="descripition"> Operators:
                  {{delivery?.operatorsNames || 'not set'}}
                </div>
              </td>
              <td>{{delivery?.holeCount || 'not set'}}</td>
              <td>{{delivery?.kgDelivered || 'not set'}}</td>
              <td>{{delivery?.detonators || 'not set'}}</td>
              <td>{{delivery?.cartridges || 'not set'}}</td>
              <td>{{delivery?.boosters || 'not set'}}</td>
              @if (delivery?.isSimpleDelivery) {
                <td>
                  <button class="btn btn-sm border-color-button  text-white border-radius-4 btn-sm"
                  (click)="openModal(delivery)">{{'GLOBAL.MODIFIER' | translate}}</button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>